import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        > div {
            width: 100%;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-direction: column;
                    margin: -15px;
                    > div {
                        padding: 15px;
                    }
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};

dateRangeStyles.toDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0;
                    `,
                    css`
                        padding-left: 10px;
                    `,
                    css`
                        padding-left: 10px;
                    `,
                    css`
                        padding-left: 10px;
                    `,
                    css`
                        padding-left: 10px;
                    `,
                ])}
        `,
    },
    labelProps: {
        color: "text.main",
    },
};

dateRangeStyles.fromDate = {
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-right: 0;
                    `,
                    css`
                        padding-right: 10px;
                    `,
                    css`
                        padding-right: 10px;
                    `,
                    css`
                        padding-right: 10px;
                    `,
                    css`
                        padding-right: 10px;
                    `,
                ])}
        `,
    },
};
